import { Feather } from "lucide-react";
import { Reveal } from "./Reveal";

export const Author = () => (
  <section data-testid="author-section" className="py-20 md:py-28">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <Reveal className="md:col-span-4 flex justify-center md:justify-start">
          <div className="relative">
            <div className="absolute -inset-6 bg-[#d4af37]/10 blur-3xl rounded-full" />
            <div className="relative w-52 h-52 sm:w-60 sm:h-60 rounded-full border border-[#d4af37]/30 bg-[#14141a] flex flex-col items-center justify-center gold-glow">
              <span className="font-serif text-6xl sm:text-7xl text-gold-gradient font-bold">LF</span>
              <span className="mt-2 font-mono text-[10px] uppercase tracking-[0.35em] text-zinc-500">Silva</span>
              <div className="absolute inset-3 rounded-full border border-dashed border-[#d4af37]/20" />
            </div>
          </div>
        </Reveal>
        <div className="md:col-span-8">
          <Reveal delay={0.1}>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">Sobre o autor</p>
            <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#f4f1ea]">
              LF Silva
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <blockquote className="mt-7 border-l-2 border-[#d4af37]/50 pl-6 font-serif italic text-lg sm:text-xl text-zinc-300 leading-relaxed">
              "Não escrevi este livro em uma torre de marfim. Escrevi depois de anos aplicando o
              estoicismo em demissões, lutos, crises de ansiedade e decisões impossíveis. Cada
              página foi testada na vida real antes de chegar até você."
            </blockquote>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-6 text-sm sm:text-base text-zinc-400 leading-relaxed">
              Pesquisador de filosofia prática há mais de uma década, LF Silva traduz os textos
              clássicos de Sêneca, Epicteto e Marco Aurélio para a linguagem de quem vive o
              Brasil do século XXI — sem academicismo, sem romantismo, sem enrolação.
            </p>
            <div className="mt-6 flex items-center gap-2 text-[#d4af37]">
              <Feather className="w-4 h-4" strokeWidth={1.5} />
              <span className="font-mono text-[11px] uppercase tracking-[0.3em]">Filosofia que se pratica</span>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
